/*
 *
 * LegalRepPEPModal
 *
 * @version 1.0.0
 * @author Mauro La Barbera
 * @since 03-Lug-2025
*/

import LegalRepPEPModal from './LegalRepPEPModalContainer'

export default LegalRepPEPModal
